import React from 'react';
import './_step2-header.scss'
import './_step2-header.dark-mode.scss'
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import _ from 'lodash';
import * as importTypes from '../../../reducer/constants';
import { getNumberValue } from '../../../../EditService/helper';

const Header = ({ isLoading, dispatchImportState, options }) => {
  const { auto_rate_fixed, auto_rate_percent } = options;

  const onChangeFixed = (e) => {
    const { value } = e.target;
    if (value === '') {
      dispatchImportState({ type: importTypes.IMPORT_CHANGE_RATE_FIXED, value: null })
    } else {
      if (/^[0-9]+(?:\.|\.[0-9]{0,4})?$/.test(value)) {
        dispatchImportState({ type: importTypes.IMPORT_CHANGE_RATE_FIXED, value })
      }
    }
  }

  const onChangePercent = (e) => {
    const { value } = e.target;
    const percentValue = getNumberValue(value);
    if (!_.isBoolean(percentValue)) {
      dispatchImportState({ type: importTypes.IMPORT_CHANGE_RATE_PERCENT, value: percentValue })
    }
  }

  const onReset = () => {
    dispatchImportState({ type: importTypes.IMPORT_RESET_RAISE })
  }

  return (
    <div className="services-import__step2-header">
      <div className="services-import__step2-header-left">
        <div className="services-import__raise">
          <div className="services-import__raise-field">
            <label htmlFor="import_fixed" className="services-import__raise-label">Fixed (1.00)</label>
            <input
              id="import_fixed"
              type="text"
              name="import_fixed"
              disabled={isLoading}
              className="form-control"
              placeholder="0"
              value={auto_rate_fixed || ''}
              onChange={onChangeFixed}
            />
          </div>
          <div className="services-import__raise-plus">+</div>
          <div className="services-import__raise-field">
            <label htmlFor="import_percent" className="services-import__raise-label">Percent (%)</label>
            <input
              type="text"
              disabled={isLoading}
              className="form-control"
              id="import_percent"
              name="import_percent"
              placeholder="0"
              value={auto_rate_percent || ''}
              onChange={onChangePercent}
            />
          </div>
        </div>
      </div>
      <div className="services-import__step2-header-right">
        <Button
          disabled={isLoading}
          onClick={onReset}
        >
          Reset raise
        </Button>
      </div>
    </div>
  );
}

Header.propTypes = {
  isLoading: PropTypes.bool,
  dispatchImportState: PropTypes.func,
  options: PropTypes.object,
};
export default Header;
